import React from 'react';
import { useDispatch } from 'react-redux';

import SectionHeader from './SectionHeader';
import Textarea from '../../components/Textarea';

const Feasibility = ({
  data: { description, showStatus },
  locales: { portfolio },
  disabled = false,
}) => {
  const {
    portfolio: { updateSectionField, updateSectionFieldReducer },
  } = useDispatch();

  const setShowStatus = (status) => {
    updateSectionFieldReducer({
      sectionName: 'feasibility',
      field: 'showStatus',
      value: status,
    });
  };

  return (
    <div className="feasibility">
      <SectionHeader
        locales={portfolio}
        showStatus={showStatus}
        sectionName={portfolio.feasibility.sectionTitle}
        setShowStatus={setShowStatus}
        mainColor="orange"
      />
      {showStatus && (
        <Textarea
          name="textarea"
          delay={700}
          value={description}
          onChange={(e) =>
            updateSectionField({
              sectionName: 'feasibility',
              field: 'description',
              name: 'feasibilityText',
              value: e.target.value,
            })
          }
          className="bmc-form-textarea textarea"
          placeholder={portfolio.page.descriptionPlaceholder}
          disabled={disabled}
        />
      )}
    </div>
  );
};

export default Feasibility;
